import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useState } from 'react';
// These two import below can be removed if not needed
import { Modal } from 'react-bootstrap';

// const NavBar = () => {
//   const { currentUser, userDetails, logout } = useAuth();
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     if (userDetails) {
//       setIsLoading(false);
//     }
//   }, [userDetails]);

//   const handleSignOut = async () => {
//     try {
//       await logout();
//       navigate('/login');
//     } catch (error) {
//       console.error('Error signing out:', error);
//     }
//   };

//   // Debug logs
//   console.log('NavBar - currentUser:', currentUser);
//   console.log('NavBar - userDetails:', userDetails);

//   if (isLoading) {
//     return null; // Don't render anything while loading
//   }

//   return (
//     <Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
//       <Container>
//         <Navbar.Brand as={Link} to="/home">
//           {userDetails?.workspaceName || 'Scheduler'}
//         </Navbar.Brand>

//         <Navbar.Toggle aria-controls="navbar-nav" />
//         <Navbar.Collapse id="navbar-nav">
//           <Nav className="me-auto">
//             <Nav.Link as={Link} to="/home">Home</Nav.Link>
            
//             {userDetails?.userType === 'employer' && (
//               <>
//                 <Nav.Link as={Link} to="/schedule-management">Schedule Management</Nav.Link>
//                 <Nav.Link as={Link} to="/employees">Employees</Nav.Link>
//                 <Nav.Link as={Link} to="/view-availability">View Availability</Nav.Link>
//               </>
//             )}
            
//             {userDetails?.userType === 'employee' && (
//               <>
//                 <Nav.Link as={Link} to="/my-schedule">My Schedule</Nav.Link>
//                 <Nav.Link as={Link} to="/availability">Availability</Nav.Link>
//               </>
//             )}
//           </Nav>
          
//           {userDetails && (
//             <Nav>
//               <Navbar.Text className="me-3">
//                 Signed in as: {userDetails.name} ({userDetails.userType})
//               </Navbar.Text>
//               <Button 
//                 variant="outline-light" 
//                 onClick={handleSignOut}
//                 size="sm"
//               >
//                 Sign Out
//               </Button>
//             </Nav>
//           )}
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// };

// export default NavBar;

const NavBar = () => {
  const { currentUser, userDetails, logout } = useAuth();
  const navigate = useNavigate();
  const [showToken, setShowToken] = useState(false);
  const [token] = useState('');

  const handleSignOut = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  if (!currentUser || !userDetails) {
    return null;
  }

  const curlCommand = token ? 
    `curl -X POST http://localhost:5001/api/schedules/generate-schedule \\
     -H "Authorization: Bearer ${token}" \\
     -H "Content-Type: application/json" \\
     -d '{"employees":[]}'` : '';

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg" className="mb-4">
        <Container>
          <Navbar.Brand as={Link} to="/home">
            {userDetails?.workspaceName || 'Scheduler'}
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/home">Home</Nav.Link>
              
              {userDetails?.userType === 'employer' && (
                <>
                  <Nav.Link as={Link} to="/schedule-management">Schedule Management</Nav.Link>
                  <Nav.Link as={Link} to="/view-availability">View Availability</Nav.Link>
                  <Nav.Link as={Link} to="/employees">Employees</Nav.Link>
                  {/* <Button 
                    variant="info" 
                    size="sm" 
                    onClick={getTokenDebug}
                    className="ms-2"
                  >
                    Get API Token
                  </Button> */}
                </>
              )}
              
              {userDetails?.userType === 'employee' && (
                <>
                  <Nav.Link as={Link} to="/my-schedule">My Schedule</Nav.Link>
                  <Nav.Link as={Link} to="/availability">Availability</Nav.Link>
                </>
              )}
            </Nav>
            
            <Nav>
              <Navbar.Text className="me-3">
                Signed in as: {userDetails?.name}
              </Navbar.Text>
              <Button 
                variant="outline-light" 
                onClick={handleSignOut}
                size="sm"
              >
                Sign Out
              </Button>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Token Modal */}
      <Modal show={showToken} onHide={() => setShowToken(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>API Token Debug Info</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <h6>Token:</h6>
            <textarea 
              className="form-control font-monospace mb-3"
              rows="5"
              value={token}
              readOnly
            />
            
            <h6>Postman Headers:</h6>
            <div className="bg-light p-3 mb-3 font-monospace">
              Authorization: Bearer {token}
            </div>
            
            <h6>curl Command:</h6>
            <pre className="bg-light p-3 mb-3 font-monospace" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
              {curlCommand}
            </pre>
          </div>
          <div className="d-flex gap-2">
            <Button 
              variant="primary" 
              onClick={() => navigator.clipboard.writeText(token)}
            >
              Copy Token
            </Button>
            <Button 
              variant="secondary" 
              onClick={() => navigator.clipboard.writeText(curlCommand)}
            >
              Copy curl Command
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default NavBar;